import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    //id: undefined, //AutoId, optional // Mã tự sinh
    type: undefined, // string, optional // Mã loại thông báo. Chi tiết xem tại: https://docs.google.com/document/d/1y_X4gFrT-Ws2cdziM00t2cE_6HJfG1JmD_uhgeEZhgs/edit
    title: undefined, //string, optional // Tiêu đề thông báo
    intro: undefined, //string, optional // Mô tả ngắn của thông báo, định dạng plain text
    link: undefined, // optional - Đường dẫn
    from: undefined, //IdRef, optional // Mã của nguồn phát sinh ra thông báo gửi. Ví dụ: user_id...
    language: undefined, // optional - Mã ngôn ngữ (vi, en)
    to: undefined, //IdRef, required // Mã người nhận
    isRead: false, //boolean, optional // Cho biết người dùng đã đọc hay chưa
    createdTime: undefined, //datetime, optional // Thời điểm tạo
    expiredTime: undefined, //datetime, optional // Thời hết hạn
    target: { //object, optional // Thông tin đích của thông báo
        value: undefined, //string, optional // Dữ liệu text của đích, ví dụ: url...
        targetId: undefined, //IdRef, optional // Mã tham chiếu của đích trong nội bộ, ví dụ: tour_id, phieu_dieu_tour_id...
    },
    targetType: undefined, //gửi theo tour hay theo tk //delete khi create hay update
    group_type: undefined, // optional Mã nhóm thông báo. (Officer, Services, Others)
};

// validation form
model.validForm = {
    //id: AutoId, optional // Mã tự sinh
    type: [ValidService.required], //string, optional // Mã loại thông báo. Chi tiết xem tại: https://docs.google.com/document/d/1y_X4gFrT-Ws2cdziM00t2cE_6HJfG1JmD_uhgeEZhgs/edit
    title: [ValidService.required], //string, optional // Tiêu đề thông báo
    intro: [], //string, optional // Mô tả ngắn của thông báo, định dạng plain text
    link: [ValidService.checkLink],
    from: [], //IdRef, optional // Mã của nguồn phát sinh ra thông báo gửi. Ví dụ: user_id...
    language: [ValidService.requiredChange], // optional - Mã ngôn ngữ (vi, en)
    to: [ValidService.required],
    isRead: [], //boolean, optional // Cho biết người dùng đã đọc hay chưa
    createdTime: [], //datetime, optional // Thời điểm tạo
    expiredTime: [], //datetime, optional // Thời hết hạn
    target: {//object, optional // Thông tin đích của thông báo
        value: [], //string, optional // Dữ liệu text của đích, ví dụ: url...
        targetId: [], //IdRef, optional // Mã tham chiếu của đích trong nội bộ, ví dụ: tour_id, phieu_dieu_tour_id...
    },
    targetType: [] //gửi theo tour hay theo tk //delete khi create hay update
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
};

// validation các form khác
model.validFormOther = {
};
model.typeNotifiType = [
    {
        code: 'AddedTourGuideToTour',
        name: 'Gửi tự động khi hướng dẫn viên được thêm vào phiếu điều tour'
    },
    {
        code: 'AddedUserToTour',
        name: 'Gửi tự động khi khách du lịch được thêm vào tour'
    },
    {
        code: 'MessageToAllTourists',
        name: 'Gửi tới tất cả Khách du lịch trên hệ thống'
    },
    {
        code: 'MessageToAllTourGuides',
        name: 'Gửi tới tất cả Hướng dẫn viên trên hệ thống'
    },
    {
        code: 'MessageToTourist',
        name: 'Gửi tới Khách du lịch'
    },
    {
        code: 'MessageToTourGuide',
        name: 'Gửi tới Hướng dẫn viên'
    },
    {
        code: 'MessageToTourGuide,Tourist',
        name: 'Gửi tới Hướng dẫn viên, Khách du lịch'
    },
    // {
    //     code: "ConfirmTourMessage",
    //     name: "Xác nhận/Từ chối tour"
    // },
    // {
    //     code: "ConfirmPDTMessage",
    //     name: "Xác nhận/Từ chối Phiếu điều tour"
    // },
];
model.typeNotifiAdminOfficer = [
    {
        code: "MessageToAllTourists",
        name: "Gửi tới tất cả Khách du lịch trên hệ thống"
    },
    {
        code: "MessageToAllTourGuides",
        name: "Gửi tới tất cả Hướng dẫn viên trên hệ thống"
    }
];
model.typeNotifiTourAgent = [
    {
        code: "MessageToTourist",
        name: "Gửi tới Khách du lịch"
    },
    {
        code: "MessageToTourGuide",
        name: "Gửi tới Hướng dẫn viên"
    },
    // {
    //     code: "ConfirmTourMessage",
    //     name: "Xác nhận/Từ chối tour"
    // },
    // {
    //     code: "ConfirmPDTMessage",
    //     name: "Xác nhận/Từ chối Phiếu điều tour"
    // },
];

model.typeNotifiTourAgentByTour = [
    {
        code: "MessageToTourist",
        name: "Gửi tới Khách du lịch"
    },
    {
        code: "MessageToTourGuide",
        name: "Gửi tới Hướng dẫn viên"
    },
    {
        code: "MessageToTourGuideAndTourist",
        name: "Gửi tới Hướng dẫn viên, Khách du lịch"
    }
];

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["createdTime", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            title: "",
            from: "",
            'target.targetId': "",
            createdTime: "",
            expiredTime: "",
            type: "",
            language: ""
        },
        valid: {
        },
        operator: {
            title: ':regex_i:',
            from: "",
            'target.targetId': "",
            createdTime: ":in_that_day:",
            expiredTime: "<+1day",
            type: "",
            language: ""
        }
    }
};

export default model;
